var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled from 'styled-components';
import { MIN_WIDTH_DATETIME_INPUT, dataSelectorId } from './helpers';
import { KeyCode } from "../../helpers";
import { CalendarSvg } from './icons';
import { InputBox } from '../helpers/InputBox';
import { InputControl } from '../helpers/InputControl';
var StyledInputBox = styled(InputBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), MIN_WIDTH_DATETIME_INPUT);
export function DatetimeInputControl(_a) {
    var className = _a.className, actions = _a.actions, control = _a.control, error = _a.error, placeholder = _a.placeholder, disabled = _a.disabled, size = _a.size, active = _a.active, opened = _a.opened, focused = _a.focused, testId = _a.testId, onChange = _a.onChange, readOnly = _a.readOnly, value = _a.value, hasEnterKeyStopPropagation = _a.hasEnterKeyStopPropagation, style = _a.style, rest = __rest(_a, ["className", "actions", "control", "error", "placeholder", "disabled", "size", "active", "opened", "focused", "testId", "onChange", "readOnly", "value", "hasEnterKeyStopPropagation", "style"]);
    return (React.createElement(StyledInputBox, __assign({}, rest, { "data-selector-id": testId, className: className, hasError: error, isDisabled: disabled, size: size, rows: 1, actions: [
            {
                icon: React.createElement(CalendarSvg, { disabled: disabled, error: error }),
                testId: dataSelectorId.dateTimeCalendarControl,
                active: opened,
                onClick: function () {
                    opened ? actions === null || actions === void 0 ? void 0 : actions.close() : actions === null || actions === void 0 ? void 0 : actions.open();
                }
            }
        ], isActive: opened || active, isFocused: focused, onFocus: control === null || control === void 0 ? void 0 : control.onFocus, onBlur: control === null || control === void 0 ? void 0 : control.onBlur, onClick: control === null || control === void 0 ? void 0 : control.onClick, onMouseDown: control === null || control === void 0 ? void 0 : control.onMouseDown, onMouseUp: control === null || control === void 0 ? void 0 : control.onMouseUp, onMouseEnter: function (e) {
            var _a;
            if (opened) {
                return;
            }
            (_a = control === null || control === void 0 ? void 0 : control.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(control, e);
        }, onMouseLeave: control === null || control === void 0 ? void 0 : control.onMouseLeave, onKeyDown: control === null || control === void 0 ? void 0 : control.onKeyDown, onKeyUp: control === null || control === void 0 ? void 0 : control.onKeyUp, onKeyPress: control === null || control === void 0 ? void 0 : control.onKeyPress, ref: control ? control.ref : useRef(null), style: style }),
        React.createElement(InputControl, { tabIndex: -1, readOnly: readOnly, placeholder: placeholder, disabled: disabled, value: value, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, "data-selector-id": 'input-control', onChange: function (e) {
                onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
            }, onKeyDown: function (e) {
                if (e.keyCode !== KeyCode.Escape && e.keyCode !== KeyCode.Enter) {
                    e.stopPropagation();
                }
            } })));
}
var templateObject_1;
//# sourceMappingURL=DatetimeInputControl.js.map